import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import CommercialOfferModel from "../../viewModels/CommercialOffers/CommercialOfferModel";
import { CommercialOffersFiltersType } from "../../components/V2Components/CommercialOfferFilters";
import SortObject from "../../types/SortObject";

const pageSizeLsKey = "commercial_offers_table_pageSize";
const pageSizeFromLs = localStorage.getItem(pageSizeLsKey);

const initialState: {
  loading: boolean;
  loadingData: boolean;
  exportLoading: boolean;
  error: boolean;
  page: number;
  pageSize: number;
  commercialOffers?: Array<CommercialOfferModel>;
  sort?: SortObject;
  total?: number;
  filters?: CommercialOffersFiltersType;
} = {
  loading: true,
  loadingData: true,
  exportLoading: false,
  error: false,

  page: undefined!,
  pageSize: pageSizeFromLs ? +pageSizeFromLs : 10,
};

const commercialOffersSlice = createSlice({
  name: "commercialOffers",
  initialState,
  reducers: {
    loadCommercialOffers(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadCommercialOffersSuccess(state, action: PayloadAction<{ commercialOffers?: Array<CommercialOfferModel>; total: number }>) {
      const { commercialOffers, total } = action.payload;

      state.loading = false;
      state.loadingData = false;
      state.commercialOffers = commercialOffers;
      state.error = false;
      state.total = total;
    },
    loadCommercialOffersReject(state) {
      state.error = true;
      state.loading = false;
      state.loadingData = false;
    },

    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject; filters: CommercialOffersFiltersType }>) {
      const { page, pageSize, filters } = action.payload;
      state.loadingData = true;
      state.page = page;
      state.error = false;
      state.pageSize = pageSize;
      state.sort = action.payload.sort;
      localStorage.setItem(pageSizeLsKey, `${pageSize}`);
      state.filters = filters;
    },

    updateCommercialOffer(state, _action: PayloadAction<Omit<CommercialOfferModel, "creationDate">>) {
      state.loadingData = true;
    },
    updateCommercialOfferSuccess(state, action: PayloadAction<CommercialOfferModel>) {
      state.loadingData = false;
      if (state.commercialOffers) {
        const index = state.commercialOffers.findIndex((x) => x.id === action.payload.id);
        if (index !== -1) {
          state.commercialOffers[index] = action.payload;
        }
      }
    },
    exportCommercialOffers(state) {
      state.exportLoading = true;
    },
    exportCommercialOffersSuccess(state) {
      state.exportLoading = false;
    },
    exportCommercialOffersReject(state) {
      state.exportLoading = false;
    },
  },
});

export default commercialOffersSlice;
